import React, { useState, useEffect } from 'react'

import { Button, Card, Form, Row, Typography, notification, Icon } from 'antd'
import { Formik } from 'formik'
import * as yup from 'yup'

import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import CustomInput from '../../components/CustomInput/customInput'
import CustomSelect from '../../components/CustomSelect/customSelect'
import CustomSwitch from '../../components/CustomSwitch/customSwitch'
import { validRule, RULES } from '../../constants/Entitlements'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'

const CreateContacts = function ({ match, history }) {
  const defaultFormValues = { active: true }
  const [formLayout] = useState('vertical')

  const [formattedCustomers, setFormattedCustomers] = useState([])
  const [formattedLocations, setFormattedLocations] = useState([])

  // Params url
  const { id } = match.params

  // Form configuration
  const [formValues, setFormValues] = useState({})

  const form = {
    initialValues: formValues,

    yupValidationCreate: yup.object().shape({
      // Create-validation-rules-body-marker
      active: yup
        .boolean()
        .typeError('must be boolean')
        .required(getMessage('isRequired', getMessage('active'))),

      contactName: yup
        .string()
        .typeError('must be string')
        .required(getMessage('isRequired', getMessage('contactName')))
    }),

    yupValidationUpdate: yup.object().shape({
      // Update-validation-rules-body-marker
      active: yup.boolean().typeError('must be boolean'),

      contactName: yup.string().typeError('must be string')
    }),

    onSubmit: async (values) => {
      console.tron.log('submit values', values)

      values.locationId = parseInt(values.locationId) || null
      values.customerId = parseInt(values.customerId) || null

      if (!id) {
        const data = {
          ...values
        }
        storeContacts(data)
      } else {
        const payload = {
          data: {
            ...values
          },
          id
        }
        for (const key in payload.data) {
          if (payload.data[key] === null) {
            delete payload.data[key]
          }
        }

        updateContacts(payload)
      }
    }
  }

  // Mount/Umount component
  useEffect(() => {
    if (id) {
      retrieveContacts(id)
    } else {
      setFormValues({})
    }

    listCustomers({ ignorePagination: true })
    listLocations({ ignorePagination: true })

    // Use-effect-mount-marker
    return () => {
      setFormValues({})
    }
  }, [])

  useEffect(() => {
    if (!id) {
      setFormValues(defaultFormValues)
    }
  }, [id])

  // Api requests
  async function storeContacts() {
    try {
      // await request(api.storeContacts(data))
      notification.success({
        description: getMessage('successStoreContacts'),
        message: getMessage('sweetAlerts.success')
      })
      setFormValues({})
      history.goBack()
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function retrieveContacts(id) {
    try {
      const response = await request(api.retrieveContacts(id))
      console.tron.log('response', response)
      setFormValues({
        ...response
      })
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function updateContacts(payload) {
    try {
      console.tron.log('updateContacts')
      const { id, data } = payload
      await request(api.updateContacts(id, data))
      notification.success({
        description: getMessage('successUpdateContacts'),
        message: getMessage('sweetAlerts.success')
      })
      history.goBack()
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function listCustomers(params) {
    try {
      const response = await request(api.listCustomers(params))
      console.tron.log('response listCustomersRequest', response)
      const formattedData = []
      response.items.map((item) => {
        return formattedData.push({
          value: item.id,
          description: item.customerName
        })
      })
      setFormattedCustomers(formattedData)
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function listLocations(params) {
    try {
      const response = await request(api.listLocations(params))
      console.tron.log('response listLocationsRequest', response)
      const formattedData = []
      response.items.map((item) => {
        return formattedData.push({
          value: item.id,
          description: item.locationName
        })
      })
      setFormattedLocations(formattedData)
    } catch (error) {
      console.tron.log(error)
    }
  }

  function getTitle() {
    return id !== null ? getMessage('updateContacts') : getMessage('createContacts')
  }

  return (
    <div>
      <Formik
        enableReinitialize
        validationSchema={!id ? form.yupValidationCreate : form.yupValidationUpdate}
        initialValues={formValues}
        onSubmit={(values, { setSubmitting, setFieldError, resetForm }) =>
          form.onSubmit(values, setSubmitting, setFieldError, resetForm)
        }
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ values, errors, handleBlur, handleSubmit, setFieldValue, submitForm }) => {
          const setFieldValueWithState = (field, value) => {
            setFormValues({
              ...formValues,
              [field]: value
            })
            return setFieldValue(field, value)
          }

          const hasAccess = validRule(RULES.CUSTOMER_CONTACT)

          return (
            <Form className="contacts-form" layout={formLayout} onSubmit={handleSubmit}>
              {/* @TODO ajustar para padrão {renderHeader()} */}
              <div style={{ paddingBottom: '0.5rem' }}>
                <div>
                  <Typography.Title level={3} style={{ margin: '0 0 0 0' }}>
                    {' '}
                    {getTitle()}{' '}
                  </Typography.Title>
                </div>
                <div
                  style={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <CustomBreadcrumb match={match} history={history} />
                  <div>
                    <div
                      style={{
                        flex: 1,
                        justifyContent: 'flex-end',
                        flexDirection: 'row',
                        display: 'flex'
                      }}
                    >
                      <Button onClick={() => history.goBack()}>
                        <Icon type="left" theme="outlined" className="default-back-icon" />
                        {getMessage('back')}
                      </Button>
                      {hasAccess && (
                        <Button type="primary" onClick={() => submitForm()}>
                          {id ? getMessage('update') : getMessage('register')}
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <Card className="ant-card gx-card ant-card-bordered">
                <Row type="flex" justify="start">
                  <CustomSwitch
                    field="active"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                  />
                </Row>

                <Row type="flex" justify="start">
                  <CustomInput
                    field="contactName"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                  />
                </Row>

                <Row type="flex" justify="start">
                  <CustomInput
                    field="phoneNumber"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                  />
                </Row>

                <Row type="flex" justify="start">
                  <CustomInput
                    field="email"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                  />
                </Row>

                <Row type="flex" justify="start">
                  <CustomInput
                    field="jobRole"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                  />
                </Row>

                <Row type="flex" justify="start">
                  <CustomSelect
                    showSearch
                    field="customerId"
                    multiple
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    values={formattedCustomers}
                  />
                </Row>

                <Row type="flex" justify="start">
                  <CustomSelect
                    showSearch
                    field="locationId"
                    multiple
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    values={formattedLocations}
                  />
                </Row>
              </Card>
            </Form>
          )
        }}
      </Formik>
    </div>
  )
}

export default CreateContacts
